/**
 * useVisibleRange Hook
 *
 * Computes the date range that should be fetched based on
 * the current date and the active calendar view.
 */

import { useMemo } from 'react';
import type { CalendarView, CalendarSettings } from '../types';
import { getVisibleRange } from '../utils';

export function useVisibleRange(currentDate: Date, view: CalendarView, settings: CalendarSettings) {
  const range = useMemo(
    () => getVisibleRange(currentDate, view, settings),
    [currentDate.getTime(), view, settings.weekStartDay, settings.agendaDaysAhead],
  );

  return range;
}
